import React, { Fragment } from 'react';
import { CSSObject, forBrands, Theme } from '@core-ui/react-stitch';
import { useLocalize } from '@core-ui/localization-provider';
import { getButtonBackgroundColorForBananaRepublic, getButtonTextColorForBananaRepublic } from '../Style/BRRedesignStyles';
// @ts-ignore
import { SIZE_FACET_ONE_SIZE, SIZE_FACET_TITLE } from '../../localization-tokens';

export type VariantButtonProps = {
  name: string,
  applied: boolean,
  onChange: () => void,
  isBRRedesignEnabled: boolean,
};

const VariantButton = ({ name, applied, onChange, isBRRedesignEnabled }: VariantButtonProps) => {
  const { localize } = useLocalize();
  const sizeVariantName =
    name.toUpperCase() === 'OMNI' ? localize(SIZE_FACET_ONE_SIZE) : name;

  const getUnderline = (): CSSObject =>
    (applied
      ? {
        display: 'block',
        content: '""',
        height: '0.25rem',
        width: '100%',
        position: 'absolute',
        bottom: '0',
        fontSize: '0.8125rem',
        left: '0',
      }
      : {});

  const getVariantButtonStyleForGap = (t: Theme): CSSObject => ({
    backgroundColor: applied ? t.color.g4 : t.color.wh,
    border: `1px solid ${t.color.g4}`,
    color: applied ? t.color.b1 : t.color.b2,
  });

  const getVariantButtonStyleForOldNavy = (t: Theme): CSSObject => ({
    backgroundColor: t.color.wh,
    border: 'none',
    color: t.color.b1,
    marginBottom: '0',
    flex: '0 1 auto',
    '&::after': {
      ...getUnderline(),
      borderColor: t.color.b1,
      backgroundColor: t.color.b1,
    },
  });

  const getVariantButtonStyleForAthleta = (t: Theme): CSSObject => ({
    // @ts-ignore
    backgroundColor: applied ? t.color.g5 : t.color.g6,
    border: '1px solid transparent',
    color: t.color.b1,
  });

  const getVariantButtonBorderForBananaRepublic = (t: Theme) => isBRRedesignEnabled ? 0 : `1px solid ${t.color.g4}`;

  const getVariantButtonStyleForBananaRepublic = (t: Theme): CSSObject => ({
    backgroundColor: getButtonBackgroundColorForBananaRepublic(t, isBRRedesignEnabled, applied),
    border: getVariantButtonBorderForBananaRepublic(t),
    ...(isBRRedesignEnabled && { outline: `1px solid ${t.color.b2}` }),
    color: getButtonTextColorForBananaRepublic(t, isBRRedesignEnabled, applied),
    ...(isBRRedesignEnabled && { fontWeight: 'bold' }),
  });

  const variantButtonStyle = (theme: Theme): CSSObject => ({
    ...theme.brandFont,
    appearance: 'none',
    flexBasis: '0',
    fontWeight: applied ? 'bold' : 'normal',
    fontSize: '0.875rem',
    flexGrow: '1',
    minHeight: '2.5em',
    position: 'relative',
    textTransform: 'uppercase',
    textAlign: 'center',
    padding: '0.0625em 0.375em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // @ts-ignore
    ...forBrands(theme, {
      gap: getVariantButtonStyleForGap,
      gapfs: getVariantButtonStyleForGap,
      on: getVariantButtonStyleForOldNavy,
      at: getVariantButtonStyleForAthleta,
      br: getVariantButtonStyleForBananaRepublic,
      brfs: getVariantButtonStyleForBananaRepublic,
    }),
    '&:nth-of-type(5)': {
      marginTop: '0.125rem',
    },
  });

  const inputStyle = (): CSSObject => ({
    opacity: 0,
    position: 'fixed',
    width: 0,
  });

  return (
    <Fragment>
      <input
        css={inputStyle}
        id={`radio-option-${sizeVariantName}`}
        name={localize(SIZE_FACET_TITLE)}
        onChange={onChange}
        type='radio'
        /*
        // @ts-ignore */
        value={applied}
      />
      <label css={variantButtonStyle} htmlFor={`radio-option-${sizeVariantName}`}>
        {sizeVariantName}
      </label>
    </Fragment>
  );
};

export default VariantButton;
